import logger from 'utils/logger.util';

const L = logger('fromObjectToEntries');

const fromObjectToEntries = (object) => {
  try {
    return Object.entries(object);
  } catch (e) {
    L.warn('()', e);
    return [];
  }
};

// noinspection JSUnusedGlobalSymbols
export default fromObjectToEntries;
